import { render, staticRenderFns } from "./MainBookCompPSList.vue?vue&type=template&id=0a0f7a30&scoped=true"
import script from "./MainBookCompPSList.vue?vue&type=script&lang=js"
export * from "./MainBookCompPSList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a0f7a30",
  null
  
)

export default component.exports